import {MdOutlineCheckBoxOutlineBlank} from 'react-icons/md';
import { completedTask, deleteTask } from '../../reducers/userReducer';
import { useDispatch } from 'react-redux';

export default function SortTodo({ task }) {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(completedTask({todo: task.todo, date:task.date}))
    dispatch(deleteTask(task.id))
  }
  return (
    <div className="bless-card todo-card">
      <h6 className='text-muted'>{task.date}</h6>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 className='text-dark'>{task.todo}</h2>
        <div onClick={()=>{onClick()}}><MdOutlineCheckBoxOutlineBlank size='40px' color='#8F8E8E'/></div>
      </div>
    </div>
  );
}
